import {ModuleController} from "../../infrastructure/controllers/module-controller";
import {BaseManagedService} from "../../infrastructure/domain-services/base-managed-service";
import {BoxScoresWidgetConfig} from "./box-scores-widget.config";
import {BoxScoresWidgetStore} from "./box-scores-widget.store";
import {BoxScoresWidgetHandlers} from "./handlers/box-scores-widget.handlers";
import {FullGameResponseDomainService} from "../../domain/full-game/services/full-game-response.domain-service";

export class BoxScoresWidgetController extends ModuleController {
  static injectables = [...BaseManagedService.injectables, BoxScoresWidgetConfig, BoxScoresWidgetStore, BoxScoresWidgetHandlers, FullGameResponseDomainService];
}
